module.exports = hasKeys

function hasKeys(source) {
    return source !== null &&
        (typeof source === "object" ||
        typeof source === "function")
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/level-filesystem/node_modules/xtend/has-keys.js
// module id = 447
// module chunks = 0